export enum AccountType {
  ClosedAccounts,
  CreditCards,
  Mortgages ,
  OtherAccounts,
  PersonalLoans,
}
